import {
  React,
  Component
} from 'imports/CommonImports';

import 'components/design/IconWithTooltip.css';

class IconWithTooltip extends Component {

  render() {
    return (
      <div className="tooltip">
      {this.props.icon}
      <span className="tooltiptext">{this.props.tooltip}</span>
      </div>
    );
  }
}

export default IconWithTooltip;



// WEBPACK FOOTER //
// ./src/components/design/IconWithTooltip.js